import { LayoutComponents } from "@jelly/lesson";
import config from "appConfig";

const components: LayoutComponents = {
  variant: "layout",
  data: {
    type: "controlsToggleExtraContent",
    options: {
      controls: [
        {
          type: "button",
          options: {},
          items: [{ name: "Real" }, { name: "Normalized" }],
        },
      ],
      controlsPosition: "bottom",
      extraContent: [
        [
          {
            type: "audioButton",
            options: {
              text: "Play sound",
              icon: "cis-volume",
              theme: "secondary",
              shape: "round",
              url: `${config.ASSETS_URL}/01/26/principle/chart-real-8m.wav`,
            },
          },
        ],
        [
          {
            type: "audioButton",
            options: {
              text: "Play sound",
              icon: "cis-volume",
              theme: "secondary",
              shape: "round",
              url: `${config.ASSETS_URL}/01/26/principle/chart-normalized-8m.wav`,
            },
          },
        ],
      ],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/01/26/principle/8m.jpg`,
                },
              },
              styles: {
                padding: "2%",
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/01/26/principle/chart-real-8m.svg`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/01/26/principle/8m.jpg`,
                },
              },
              styles: {
                padding: "2%",
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/01/26/principle/chart-normalized-8m.svg`,
                },
              },
            },
          },
        ],
      ],
    },
  },
};

export default components;
